/* eslint-disable func-names */
/**
 * header 中添加的字段名：risk-uuid
523：需要进行极验校验
524：极验校验出现异常

/register：极验注册接口拿到 unique
/validate：校验接口，传校验参数和 unique
校验接口返回成功后，重新调用业务接口，header 中添加 risk-uuid：unique
*/
import { Toast } from 'vant';
import '@/service/lib/gt';

import { getGtInitData, gtValidate } from './api/gt';
import { errorHandler } from './helper';

let gtInstance = null;

function gt() { return this; }

gt.prototype.init = () => new Promise((resolve, reject) => {
  const t = new Date().getTime();
  getGtInitData(t).then(gtRes => {
    const gtData = gtRes.data;
    window.initGeetest(
      {
        // 以下 4 个配置参数为必须，不能缺少
        gt: gtData.gt,
        challenge: gtData.challenge,
        offline: !gtData.success, // 表示用户后台检测极验服务器是否宕机
        new_captcha: gtData.new_captcha, // 用于宕机时表示是新验证码的宕机
        timeout: '5000',
        product: 'bind', // 产品形式，包括：float，popup
        hideClose: false, // 是否隐藏后续验证界面的关闭按钮
        https: true,
        remUnit: 8.2,
        // 更多前端配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
      },
      captchaObj => {
        captchaObj.unique = gtData.unique;
        // captchaObj.appendTo(`#${idName}`);
        captchaObj.onError(error => {
          console.log('极验初始化失败', error);
          reject(null);
        });
        captchaObj.onReady(() => {
          console.log('ready', captchaObj);
          resolve(captchaObj);
        });
      },
    );
  });
});

gt.prototype.vertifyGt = async function () {
  //  try to call gt's counts when onError
  let reTryCount = 0;
  const Supper = this;
  // hasn't init gt

  console.log('gtInstance:', gtInstance);
  return new Promise(async (resolve, reject) => {
    // 由于每次的 gt 初始化参数用一次就失效，每次都要重新初始化
    gtInstance = await Supper.init();
    if (!gtInstance/* 初始化失败 */) {
      reject();
    }
    gtInstance.onSuccess(async () => {
      // 获取校验参数
      const res = gtInstance.getValidate();
      // eslint-disable-next-line camelcase
      const { geetest_challenge, geetest_seccode, geetest_validate } = res;
      // 传给后端校验
      const validateRes = await gtValidate({
        unique: gtInstance.unique,
        challenge: geetest_challenge,
        seccode: geetest_seccode,
        validate: geetest_validate,
      });
      if (errorHandler(validateRes)) {
        resolve(gtInstance.unique);
        gtInstance.destroy();
        gtInstance = null;
        return;
      }
      reject();
    });
    gtInstance.onClose(() => {
      Toast({
        message: '请先通过验证',
        duration: 2000,
      });
      // 失败2次则跳出
      if (reTryCount > 1) {
        reject();
        return;
      }

      reTryCount += 1;
      // 重新调起极验
      setTimeout(() => {
        gtInstance.verify();
      }, 2000);
    });
    gtInstance.onError(() => {
      // 失败2次则跳出
      if (reTryCount > 1) {
        Toast('请刷新页面重试');
        reject();
        return;
      }
      reTryCount += 1;
      // 重新调起极验
      gtInstance.verify();
    });
    gtInstance.verify();
  });
};

export default gt;
